import P from 'prop-types';

import { group, stringInputSpec } from '../../lib/editing-configs';
import UniversalContainer, {
  universalContainerPropTypes,
  universalContainerDefaultProps,
} from '../universal-container';
import { Auth0Buttons } from '../auth0-buttons/auth0-buttons';

const UniversalAuthButton = ({ isSignedIn, componentName, ...container }) => {
  return (
    <UniversalContainer {...container}>
      <Auth0Buttons.Container>
        <Auth0Buttons.AppleButton />
        <Auth0Buttons.GoogleButton />
        <Auth0Buttons.EmailLink />
        <Auth0Buttons.LegalLinks />
      </Auth0Buttons.Container>
    </UniversalContainer>
  );
};

UniversalAuthButton.displayName = 'UniversalAuthButton';

UniversalAuthButton.propTypes = {
  isSignedIn: P.bool,
  componentName: P.string,
  ...universalContainerPropTypes,
};

UniversalAuthButton.defaultProps = {
  isSignedIn: false,
  componentName: 'auth-button',
  ...universalContainerDefaultProps,
};

UniversalAuthButton.getEditingConfig = (
  componentDocument,
  fieldName = 'universal-auth-button'
) => {
  return [
    ...UniversalContainer.getEditingConfig(
      componentDocument,
      'Button Container',
      ['backgroundColor', 'padding', 'margin'],
      fieldName
    ),
    group('Tracking', [
      stringInputSpec(`${fieldName}.componentName`, 'Component Name', {
        help: 'For Tracking Purposes',
      }),
    ]),
  ];
};

export default UniversalAuthButton;
